var option_default = {
  "option": "g-pPh",
  "user_choice": "_9NbmZ",
  "check": "CqGGJ",
  "image": "_2EkHM",
  "input": "g5jgi",
  "title": "dW-B2",
  "centered": "WKPWT",
  "with_result": "_4BPA1",
  "list": "kstws",
  "with_image": "cSRz7",
  "progress": "rnfly",
  "progress_value": "PJ6ql",
  "label": "-VsTc",
  "cta": "cdyOa",
  "adornment_icon": "QaCEq",
  "remove": "_7QELg",
  "removeButton": "UhZ6o",
  "removeButtonIcon": "InRss",
  "overlay": "_8eoQo",
  "shown": "rKbPv",
  "dark": "_21OEp",
  "spinner": "eyRUS",
  "spin": "oifTW"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
